export default "__VITE_ASSET__CQp4LEgw__"